import api from './api';

export const offerService = {
  async getOffers() {
    const response = await api.get('/offers');
    return response.data;
  },

  async createOffer(data) {
    const response = await api.post('/offers', data);
    return response.data;
  },

  async updateOffer(id, data) {
    const response = await api.put(`/offers/${id}`, data);
    return response.data;
  },

  async deleteOffer(id) {
    const response = await api.delete(`/offers/${id}`);
    return response.data;
  },
};

